if (!customElements.get('soapyard-pro')) {
  customElements.define('soapyard-pro', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      if (this.querySelector('[data-order-success]')) {
        try { sessionStorage.removeItem('soapyard-pro-selection-v2'); } catch {}
      }
      const form = this.querySelector('form');
      if (!form || !this.querySelector('[data-submit]')) return;
      const plans = JSON.parse(this.querySelector('[data-pro-plans]').textContent);
      const prices = JSON.parse(this.querySelector('[data-pro-prices]').textContent);
      const strings = JSON.parse(this.querySelector('[data-pro-strings]').textContent);
      const quantityInputs = [...this.querySelectorAll('[data-bundle], [data-custom]')];
      const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
      const mode = () => form.querySelector('[name="pro_mode"]:checked').value;
      const result = this.querySelector('[data-order-summary]');
      const error = this.querySelector('[data-selection-error]');
      const submit = this.querySelector('[data-submit]');
      let valid = false;
      const calculate = () => {
        let cents = 0;
        let count = 0;
        let malformed = false;
        const lines = [strings.selection, ''];
        this.querySelectorAll('[data-panel]').forEach(panel => {
          const active = panel.dataset.panel === mode();
          panel.hidden = !active;
          panel.querySelectorAll('input').forEach(input => { input.disabled = !active; });
        });
        const quantities = {};
        quantityInputs.filter(input => !input.disabled).forEach(input => {
          const n = input.value === '' ? 0 : Number(input.value);
          if (!Number.isInteger(n) || n < 0 || n > Number(input.max) || input.validity.badInput) {
            malformed = true;
            return;
          }
          if (!n) return;
          if (input.dataset.bundle) {
            const plan = plans.find(item => item.id === input.dataset.bundle);
            const pack = plan.formats[input.dataset.format];
            cents += pack.cents * n;
            count += pack.count * n;
            lines.push(`${n} × Lot ${plan.name} — ${pack.name} — ${money(pack.cents * n)} HT`);
            pack.lines.forEach(line => {
              lines.push(`  ${line.label} : ${line.rope * n} ${strings.rope} + ${line.tin * n} ${strings.tin}`);
              const q = quantities[line.handle] ||= { rope: 0, tin: 0, carton: 0 };
              q.rope += line.rope * n;
              q.tin += line.tin * n;
            });
          } else {
            const format = input.dataset.custom;
            const row = input.closest('tr');
            const label = row.querySelector('th').childNodes[0].textContent;
            const price = prices[format];
            cents += n * price;
            count += n * (format === 'carton' ? 28 : 1);
            lines.push(`${label} : ${n} × ${strings[format]} — ${money(n * price)} HT`);
            const q = quantities[row.dataset.handle] ||= { rope: 0, tin: 0, carton: 0 };
            q[format] += n;
          }
        });
        const vat = Math.round(cents * 0.2);
        this.querySelector('[data-count]').textContent = count ? `${count} ${strings.count}` : strings.empty;
        this.querySelector('[data-total-ht]').textContent = money(cents);
        this.querySelector('[data-vat]').textContent = money(vat);
        this.querySelector('[data-total-ttc]').textContent = money(cents + vat);
        this.querySelector('[data-volume]').hidden = cents < 30000;
        valid = !malformed && cents >= 15000;
        error.textContent = malformed ? strings.invalid : (cents > 0 && cents < 15000 ? strings.too_small : '');
        error.hidden = !error.textContent;
        submit.disabled = !valid;
        lines.push('', `${count} ${strings.count}`, `${strings.total} : ${money(cents)}`, `${strings.vat} : ${money(vat)}`, `${strings.ttc} : ${money(cents + vat)}`, strings.pending);
        result.value = lines.join('\n');
        this.selection = { mode: mode(), cents, count, quantities };
        try {
          sessionStorage.setItem('soapyard-pro-selection-v2', JSON.stringify({ mode: mode(), quantities: quantityInputs.map(input => input.value) }));
        } catch {}
      };
      try {
        const saved = JSON.parse(sessionStorage.getItem('soapyard-pro-selection-v2'));
        if (saved && ['bundles', 'custom'].includes(saved.mode)) {
          form.querySelector(`[name="pro_mode"][value="${saved.mode}"]`).checked = true;
          if (saved.quantities?.length === quantityInputs.length) quantityInputs.forEach((input, i) => { input.value = saved.quantities[i]; });
        }
      } catch {}
      form.addEventListener('input', calculate);
      form.addEventListener('change', calculate);
      form.addEventListener('submit', event => {
        calculate();
        if (!valid) {
          event.preventDefault();
          error.hidden = false;
          error.textContent = strings.too_small;
          error.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        let redirect = form.querySelector('[name="return_to"]');
        if (!redirect) {
          redirect = document.createElement('input');
          redirect.type = 'hidden';
          redirect.name = 'return_to';
          form.appendChild(redirect);
        }
        redirect.value = location.pathname + location.search;
      });
      calculate();
    }
  });
}
